import { OfferState } from "./types";
import { defineStore } from "pinia";

export const useOfferStore = defineStore("offer", {
  state: (): OfferState => ({
    memberOfferCode: null,
    memberOfferType: null
  }),
  persist: {
    storage: localStorage
  },
  actions: {
    setState(booking: OfferState) {
      this.$patch(booking);
    }
  }
});
